module.exports = __webpack_public_path__ + "static/media/youtube-brands.f78c1e5d.svg";